module.exports = __webpack_public_path__ + "img/22.224a6673.png";